"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require("react-addons-css-transition-group");

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _onEscape = require("utils/onEscape");

var _onEscape2 = _interopRequireDefault(_onEscape);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _PopupContainer = require("../AppPopupContainer/PopupContainer");

var _PopupContainer2 = _interopRequireDefault(_PopupContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogContainer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(DialogContainer, _React$Component);

  function DialogContainer() {
    (0, _classCallCheck3.default)(this, DialogContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DialogContainer.__proto__ || (0, _getPrototypeOf2.default)(DialogContainer)).call(this));

    _this.closeDialog = _this.closeDialog.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DialogContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (__CLIENT__) {
        (0, _onEscape2.default)("dialog", this.closeDialog);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (__CLIENT__) {
        (0, _onEscape2.default)("dialog");
      }
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      if (this.dialogComponent) {
        if (this.dialogComponent.forceClose) {
          this.dialogComponent.forceClose();
        } else if (this.dialogComponent.props.onCloseNo) {
          this.dialogComponent.props.onCloseNo();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var styles = require("./DialogContainer.scss");

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: {
            enter: styles["DialogContainer--appear"],
            enterActive: styles["DialogContainer--appear-active"],
            leave: styles["DialogContainer--leave"],
            leaveActive: styles["DialogContainer--leave-active"],
            appear: styles["DialogContainer--appear"],
            appearActive: styles["DialogContainer--appear-active"]
          },
          transitionAppear: true,
          transitionAppearTimeout: 100,
          transitionEnterTimeout: 100,
          transitionLeaveTimeout: 100
        },
        !this.props.closed && _react2.default.createElement(
          _PopupContainer2.default,
          { onClose: this.closeDialog },
          _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
            ref: function ref(instance) {
              _this2.dialogComponent = instance;
            }
          })
        )
      );
    }
  }]);
  return DialogContainer;
}(_react2.default.Component), _class.propTypes = {
  children: _react.PropTypes.element.isRequired
}, _class.contextTypes = {
  store: _react.PropTypes.object,
  router: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp);
exports.default = DialogContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DialogContainer/DialogContainer.jsx
// module id = 2618
// module chunks = 0